import React from "react";

import { GENERAL_TYPE, GENERAL_TYPE_NAME } from "../../../../lib/enums";

interface IProps {
  generalsString: string;
}

const DetailsGenerals = ({ generalsString }: IProps) => {
  const generalsParsed = generalsString.substring(0, generalsString.length - 1).split("|");
  generalsParsed.sort(
    (p1, p2) => Number.parseInt(p2.substring(1, 2), 10)
      - Number.parseInt(p2.substring(1, 2), 10)
  );
  return <>{generalsParsed.map((gString) => {
    const gDetail = gString.split(";");

    return <>
      <span>
        {GENERAL_TYPE_NAME[Number.parseInt(gDetail[1], 10)]}:&nbsp;Level&nbsp;
        <em>{gDetail[2]}</em><br />
        {Number.parseInt(gDetail[1], 10) !== GENERAL_TYPE.ECONOMIST
        && <>
          Attack <em>{gDetail[3]}</em><br />
          Defence <em>{gDetail[4]}</em><br />
        </>}
        {gDetail.slice(5).map(d => <>{d.split(":")[0]}&nbsp;<em>{d.split(":")[1]}</em><br/></>)}
      </span>
      <br />
    </>
  })}</>
}

export default DetailsGenerals;
